<script setup lang="ts">
import { defineEmits } from 'vue';

defineEmits(['next']);
</script>

<template>
  <div class="inner_content">
    <div class="main_content">
      <div class="inner_content top_test">
        <div class="main_content">
          <div class="lp_title">
            <p class="step">
              <span class="num">8</span><span class="bold">ステップ</span>
              でわかる
            </p>
            <h1>
              <picture>
                <source srcset="@/images/shindan/nensyu_logo_pc.png" media="(min-width: 769px)"> 
                <source srcset="@/images/shindan/nensyu_logo_sp.png" media="(max-width: 768px)"> 
                <img src="@/images/shindan/nensyu_logo_pc.png" alt="薬剤師の年収診断"> 
              </picture>
            </h1>
          </div>
          <p class="text_kakko">
            <img
              class="kakko01"
              src="@/images/shindan/kakko01.png"
              alt=""
            >
            あなたの年収は<span>高い？低い？</span>
            <img
              class="kakko02"
              src="@/images/shindan/kakko02.png"
              alt=""
            > 
          </p>
          <div class="box_orange_btn">
            <div 
              class="orange_btn"
              @click.once="$emit('next')" 
            >
              <p class="inner_orange">
                診断スタート
                <span>（所要時間 2分）</span>
              </p>
            </div>
            <p class="img_woman">
              <picture>
                <source
                  srcset="@/images/shindan/img_woman_pc.png"
                  media="(min-width: 769px)"
                >
                <source
                  srcset="@/images/shindan/img_woman_sp.png"
                  media="(max-width: 768px)"
                >
                <img
                  src="@/images/shindan/img_woman_pc.png"
                  alt="あなたの年収は 高い？低い？"
                >
              </picture>
            </p>
            <p class="img_male">
              <picture>
                <source
                  srcset="@/images/shindan/img_male_pc.png"
                  media="(min-width: 769px)"
                >
                <source
                  srcset="@/images/shindan/img_male_sp.png"
                  media="(max-width: 768px)"
                >
                <img
                  src="@/images/shindan/img_male_pc.png"
                  alt="あなたの年収は 高い？低い？"
                >
              </picture>
            </p>
          </div>
          <p class="bn">
            <picture>
              <source
                srcset="@/images/shindan/bn_no1_pc.png"
                media="(min-width: 501px)"
              >
              <source
                srcset="@/images/shindan/bn_no1_sp.png" 
                media="(max-width: 500px)"
              >
              <img
                src="@/images/shindan/bn_no1_pc.png"
                alt="薬剤師登録者数 No.1"
              >
            </picture>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
